import useSWRFetcher from "../commonly-stored/fetcher";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { useCallback } from "react";
import { InventoryItemsResponse } from "./getInventoryItems";

export default function useGetPanelsForProject(boardId: string) {
  const fetcher = useSWRFetcher<InventoryItemsResponse>();

  const { data, mutate } = useSWR<InventoryItemsResponse>(
    `${settings.api_url}/boards/${boardId}/panels`,
    fetcher,
  );

  const refreshPanelsForProject = useCallback(() => {
    void mutate();
  }, [mutate]);

  return {
    panelsForProject: data || null,
    refreshPanelsForProject,
  };
}
